import type { Vehicle, VehicleDerivative } from '@/features/vehiclesearch';
import type { VehicleIdentity } from './vehicleIdentity';

const normalise = (value: string | null | undefined): string | undefined => {
    const cleaned = (value ?? '').replace(/\s+/g, '').toUpperCase();
    return cleaned === '' ? undefined : cleaned;
};

export function agreementCheckIdentity(vehicle: Vehicle | VehicleDerivative | null): VehicleIdentity | null {
    if (vehicle?.type !== 'vehicle') return null;

    const vin = normalise(vehicle.vin);
    const vrm = normalise(vehicle.current_status?.vrm);
    if (!vin && !vrm) return null;

    return { ...(vin && { vin }), ...(vrm && { vrm }) };
}
